import { Editor, Extensions, JSONContent } from '@tiptap/core';
import { Node } from '@tiptap/pm/model';
import { Transaction } from '@tiptap/pm/state';
import { UseEditorOptions } from '@tiptap/react';
import { FC } from 'react';
import { ExtensionConfig } from 'components/organisms/document-editor/types';
import { DefaultFloatingToolbarConfig as DefaultFloatingToolbarConfigType } from './toolbar/types';

export type EditorNodeInfo = {
  node: Node;
  start: number;
  end: number;
  contentStart: number;
  contentEnd: number;
};

type BaseFloatingToolbarConfig = {
  enabled: true;
};
export type DefaultFloatingToolbarConfig = BaseFloatingToolbarConfig &
  DefaultFloatingToolbarConfigType;
export type CustomFloatingToolbarConfig = BaseFloatingToolbarConfig & {
  toolbar: FC<{ editor: Editor }>;
};
type EnabledFloatingToolbarConfig =
  | DefaultFloatingToolbarConfig
  | CustomFloatingToolbarConfig;

export type EditorFloatingToolbarConfig =
  | {
      enabled: false;
    }
  | EnabledFloatingToolbarConfig;
export const defaultFloatingToolbarConfig: EditorFloatingToolbarConfig = {
  enabled: true,
};
export type RichTextEditorValueType = JSONContent | JSONContent[] | string;
export interface RichTextEditorProps<
  ValueType extends RichTextEditorValueType,
> {
  value?: ValueType;
  placeholder?: string;
  onChange?: (
    value: ValueType,
    editor: Editor,
    transaction: Transaction,
  ) => void;
  onInitialize?: (editor: Editor) => void;
  className?: string;
  floatingToolbarConfig?: EditorFloatingToolbarConfig;
  readonly?: boolean;
  isInsertOnlyMode?: boolean;
  extensions?: Extensions;
  editorOptions?: UseEditorOptions;
  hasTableToolbar?: boolean;
  extensionConfig?: Partial<ExtensionConfig>;
  isChatOpen?: boolean;
  documentTitle?: string;
}
